<script>
    import { metaInfo } from "@/core/MetaInfo";

    export default {
        name: "TestDriveOrders",
        data() {
            return {
                list: [],
                modelsList: [],
            };
        },
        mounted() {
            Promise.all([
                this.$store.autoAdminApi.getModels(),
                this.$store.autoAdminApi.getTestDriveOrders(),
            ]).then((data) => {
                this.modelsList = data[0].data.items;
                this.list = data[1].data.items;
            });
        },
        methods: {
            selected(item) {
                this.$router.push({ name: "TestDriveOrderEdit", params: { slug: item.id } });
            },
            // getList() {
            //     this.$store.autoAdminApi.getTestDriveOrders().then(({ data }) => {
            //         this.list = data.items;
            //     });
            // },
            getStatus(value) {
                let filtered = {
                    closed: "Закрыт",
                    in_progress: "В процесс",
                    new: "Новый",
                };
                return filtered[value];
            },
            getName(id) {
                return this.modelsList.find((model) => model.id === id).name;
            },
        },
        metaInfo() {
            return metaInfo.getMeta("home");
        },
    };
</script>

<template>
    <section class="section">
        <div class="field">
            <!--            <b-button tag="router-link" to="/testdrive-points/new" type="is-primary" outlined>-->
            <!--                Добавить точку-->
            <!--            </b-button>-->
        </div>

        <h1 class="title">Тестдрайвы</h1>
        <b-table :data="list" @select="selected" hoverable>
            <b-table-column field="modelId" label="Модель" sortable v-slot="props">
                {{ getName(props.row.modelId) }}
            </b-table-column>
            <b-table-column field="status" label="Статус" sortable v-slot="props">
                {{ getStatus(props.row.status) }}
            </b-table-column>
            <b-table-column field="contact.name" label="Имя" sortable v-slot="props">
                {{ props.row.contact.name }}
            </b-table-column>
            <b-table-column field="time" label="Время" sortable v-slot="props">
                {{ props.row.time }}
            </b-table-column>

            <b-table-column field="id" label="Id" sortable v-slot="props">
                {{ props.row.id }}
            </b-table-column>
        </b-table>
    </section>
</template>

<style lang="scss"></style>
